import React, { FC } from 'react';
import { emailValidator } from '@common/utils';
import { MultiSteps } from '@common/interfaces';
import { validateWithUser } from '@pages/MobilityPlannerPage/utils';
import { useNonSpammyFieldState } from '@common/hooks';
import { TextField } from '../../../../../legacyInputs';
import css from '../styles.module.scss';

const ManagerEmailField: FC = () => {
  const { value: no_passengers } = useNonSpammyFieldState<boolean>('no_passengers');

  return (
    <div className={css.field}>
      <TextField
        className={css.input}
        multistepName={MultiSteps.MainInfo}
        name="manager_email"
        disabled={no_passengers}
        validate={validateWithUser(emailValidator)}
        label="Manager Email"
        data-testid="mobility-planner-edit-form-manager-email"
      />
    </div>
  );
};

export default ManagerEmailField;
